export default "__VITE_ASSET__3d040e80__"